export class Package {
  packageId: string;
  name: string;
  description: string;
  disclaimer: string;
  installationTimeInHours: number;
  categoryId: string;
  skillId: string;
  packageNumber: string;
  imageUrl: string;
  customLines: productLines[];
  priceCostMaterials: number;
  priceMaterialsHour: number;
  priceMaterialHourStartFee: number;
  productLines: productLines[];
  productImages: string[];
  selectedMarginType: string;
  hoursCostPrice: number;
  hoursSalesPrice: number;
  profitMargin: number;
  totalPrice: string;
  startingPrice: number;
  showInShop: true;
  costPrice: number;
  salesPrice: number;
  salesVat: number;
  discount: number;
  priceGroupId: string
}

export class productLines {
  id: string;
  name: string;
  costPrice: number;
  salesPrice: number;
  quantity: number;
  totalCostPrice: number;
  totalSalesPrice: number;
  profit: number;
  discount: number;
  sortOrder: number
}
